import { HttpClient } from './HttpClient';

const apiVersion = process.env.REACT_APP_API_VERSION || 'v1';

export default HttpClient.getInstance(`/api/${apiVersion}`);
